/** Extract a display-friendly hostname from a URL ("www." stripped). */
export function domainOf(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

/** Display title for an article — extraction can yield a null title. */
export function titleOf(a: { title?: string | null; url: string }): string {
  return a.title || a.url;
}
